module.exports = __webpack_public_path__ + "static/img/fuwuleirong_27.b64a0031.jpg";